module.exports = __webpack_public_path__ + "img/4-道具中心-01.0965ac8c.png";